import type { BelongingsFeatureConfig } from '../../../types/insurances/BelongingsFeatureConfig';

export const belongings: BelongingsFeatureConfig = {
    overview: {
        details: {
            showContractedInsurances: false,
            showVariant: false,
            showPackage: false,
            showContractHolder: false,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
